<template>
  <div class="header">
    <div class="branding">
      <img src="../assets/img/header.png" alt="header it4anxiety head" />
      <p>IT4Anxiety</p>
    </div>
    <nav class="navigation" id="navigation">
      <ul class="menu" v-bind:class="{ 'is-active': isMenuActive }" @click="askMenu()">
        <li><a href="#projet" class="item2">Le projet</a></li>
        <li><a href="#partenaires" class="item2">Partenaires</a></li>
        <li><a href="#axes" class="item2">Activités</a></li>
        <li><a href="#timeline" class="item2">Timeline</a></li>
        <!-- <li><a href="#financement" class="item2">Financement</a></li> -->
        <li><a href="#more" class="item2">En savoir plus</a></li>
      </ul>
    </nav>
    <button class="hamburger hamburger--collapse" v-bind:class="{ 'is-active': isMenuActive }" type="button" aria-label="Menu" aria-controls="navigation" :aria-expanded="isMenuActive" @click="askMenu()">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
  </div>
</template>

<script>
export default {
  name:"menuv2",
  data(){
    return{
      isMenuActive:false,
    }
  },
  methods:{
    askMenu(){
      // console.log("ask menu");
      this.isMenuActive = !this.isMenuActive;
    }
  }
};
</script>

<style lang="scss" scoped>
$color-primary:#0C4DA2;
$color-secondary:#FBBF1C;
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .branding {
    height: 40px;
    display: flex;
    align-self: flex-start;
    img {
      height: 61px;
    }
    p{
      padding: 5px 15px 5px 15px;
      font-size: 30px;
      text-transform: uppercase;
      font-weight: bold;
      color:$color-secondary;
    }
  }
}

.navigation{
  display: flex;
}

.menu {
  position:fixed;
  top:61px;
  right: -100vw;
  width: 100%;
  height: calc(100vh - 61px);
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all .3s ease-in-out;
  &.is-active{
    right: 0;
  }
  li {
    a {
      font-size: 20px;
      display: block;
      padding: 5px 10px 5px 10px;
    }

  }
}

@media screen and (min-width: 900px) {
  .menu {
    flex-direction: row;
    position:static;
    height: 61px;
    li {
      a {
        padding: 5px 5px 5px 5px;
        margin: 0 5px 0 5px;
      }
    }
  }
  .hamburger{
    display: none;
  }
}

.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after{
  background-color:$color-primary;
}

.hamburger.is-active .hamburger-inner, .hamburger.is-active .hamburger-inner::before, .hamburger.is-active .hamburger-inner::after{
  background-color:$color-primary;
}

/*ITEM 2*/
.item2 {
	position: relative;
	overflow: hidden;
  color:#0C4DA2;
  // transition: all .3s ease-in-out;
}
.item2:hover{
  color:#0C4DA2;
}
.item2:before {
	content: "";
	position: absolute;
	top:3px;
	left: -100%;
	height: 100%;
	width: 100%;
	overflow: hidden;
	border-top: 2px solid #0C4DA2;
	transition:all 0.4s ease-out;
}
.item2:after {
	content: "";
	position: absolute;
	top:0;
	right: -100%;
	height: 100%;
	width: 100%;
	border-bottom: 2px solid #fbbf1c;
	transition:all 0.3s ease-out;
}

.item2:hover::before {
	left: 0;
	height: 100%;
}
.item2:hover::after {
	right: 0;
	height: 100%;
}

.europeanflag{
  padding: 10px;
  img{
    display: block;
    height: 34px!important;
    width:auto;
  }
}

.europeanflag{
  display: none;
}

@media screen and (min-width: 500px) {
  .europeanflag{
  display: block;
}
}

</style>